import * as Yup from "yup";
import servicoSchema from "./nfse-servico.validator";

const nfseValidator = Yup.object().shape({
  clienteId: Yup.number().typeError("Cliente").required("Cliente"),
  serieDocumento: Yup.string().required("Série"),
  clienteNome: Yup.string().required("Cliente"),
  clienteCnpjCpf: Yup.string().required("Cliente"),
  clienteEnderecoRua: Yup.string().nullable(),
  clienteEnderecoNumero: Yup.string().nullable(),
  clienteEnderecoBairro: Yup.string().nullable(),
  clienteEnderecoComplemento: Yup.string().nullable(),
  clienteEnderecoCidade: Yup.string().nullable(),
  clienteEnderecoUf: Yup.string().nullable(),
  clienteEnderecoCep: Yup.string().nullable(),
  descricaoServico: Yup.string().required("Descrição do serviço"),
  dataPrestacao: Yup.date().nullable(),
  servicos: Yup.array()
    .of(servicoSchema)
    .min(1, "É obrigatório informar ao menos um serviço")
    .required("É obrigatório informar ao menos um serviço"),
});

export default nfseValidator;
